import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import { OverlayTrigger } from "react-bootstrap";

class OverlayRenderer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showOverlay: props.forceOverlay,
      elementWidth: 0,
      parentWidth: 0,
    };
  }

  componentDidMount() {
    if (!this.props.forceOverlay) {
      this._checkForOverlay();
    }
  }

  componentDidUpdate() {
    if (!this.props.forceOverlay) {
      const { elementWidth, parentWidth } = this.state;
      const newElementWidth = ReactDOM.findDOMNode(this.refs[`children`])
        .offsetWidth;
      const newParentWidth = ReactDOM.findDOMNode(this).parentNode.offsetWidth;

      if (elementWidth !== newElementWidth || parentWidth !== newParentWidth) {
        this._checkForOverlay(newElementWidth, newParentWidth);
      }
    }
  }

  _checkForOverlay(newElementWidth = null, newParentWidth = null) {
    const cellPadding = 19.9; // Actually 20 but keeping that 0.1 out solves some problems...
    let elementWidth =
      newElementWidth ||
      ReactDOM.findDOMNode(this.refs[`children`]).offsetWidth;
    let parentWidth =
      newParentWidth || ReactDOM.findDOMNode(this).parentNode.offsetWidth;

    this.setState({
      showOverlay: elementWidth >= parentWidth - cellPadding,
      elementWidth,
      parentWidth,
    });
  }

  render() {
    const { placement, overlay, overlayedClassName } = this.props;
    const { showOverlay } = this.state;
    const children = React.cloneElement(this.props.children, {
      ref: `children`,
    });

    return showOverlay ? (
      <OverlayTrigger placement={placement} overlay={overlay}>
        <div className={overlayedClassName}>{children}</div>
      </OverlayTrigger>
    ) : (
      children
    );
  }
}

OverlayRenderer.propTypes = {
  children: PropTypes.node,
  forceOverlay: PropTypes.bool,
  overlayedClassName: PropTypes.string,
  placement: PropTypes.string,
  overlay: PropTypes.node,
};

OverlayRenderer.defaultProps = {
  forceOverlay: false,
};

export default OverlayRenderer;



// WEBPACK FOOTER //
// ./src/components/common/OverlayRenderer.js